module.exports = __webpack_public_path__ + "static/media/Lesson-9-17-How-Big-is-our-Reward.a1156266.pdf";